import React from "react";
import { LazyLoadComponent, LazyLoadImage } from 'react-lazy-load-image-component';

export const PaymentMethod = ({
    title,
    description,
    postDescription,
    isImageAvailable,
    imageSrc,
    imageAlt
}) => {
    return (
        <>
            <h6>{title}</h6>
            <p className="product-font-size">
                {description}
                {isImageAvailable && imageSrc && imageAlt && (
                    <LazyLoadComponent>
                        <picture>
                            <LazyLoadImage className="p-1" height={25} width={25} src={imageSrc} alt={imageAlt} />
                        </picture>
                    </LazyLoadComponent>
                )}
                {postDescription}
            </p>
        </>
    );
}